import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: getModules(),

  state: {
    snackbar: {
      text: false,
      color: "success",
      isShow: false,
    },
    loading: false,
    size: {
      width: 992,
      height: 992,
    },
  },

  mutations: {
    SET_SNACKBAR(state, snackbar) {
      snackbar.isShow = true;
      state.snackbar = snackbar;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_SIZE(state, { width = 0, height = 0 }) {
      state.size = { width, height };
    },
  },

  actions: {
    SET_SNACKBAR({ commit }, payload) {
      commit("SET_SNACKBAR", payload);
    },
    SET_LOADING({ commit }, payload) {
      commit("SET_LOADING", payload);
    },
    SET_SIZE({ commit }, { width, height }) {
      commit("SET_SIZE", { width, height });
    },

    async INIT_STATES({ dispatch }) {
      await dispatch("auth/INIT_USER").then(async (status) => {
        if (status) {
          // await dispatch("region/INIT_REGIONS");
          dispatch("app-settings/INIT_APP_SETTINGS");
        }
      });
    },
  },

  getters: {
    GET_SIZE: (state) => state.size,
    GET_LOADING: (state) => state.loading,

    GET_SNACKBAR: (state) => state.snackbar,
  },
});

function getModules() {
  const modulesCtx = require.context("./", true, /[A-Za-z0-9-_,\s]+\.js$/i);

  const modules = {};
  const ignores = [];

  modulesCtx.keys().forEach((key) => {
    if (key != "./index.js" && ignores.indexOf(key) < 0) {
      const name = key.replace("./", "").replace(".js", "");
      let module = modulesCtx(key);
      module.namespaced = true;
      modules[name] = module;
    }
  });

  return modules;
}
